export const stencilThickness = [
  {
    value: '',
    text : 'Select One',
  },
  {
    value: '0.003',
    text : '0.003"',
  },
  {
    value: '0.004',
    text : '0.004"',
  },
];

export const material = [
  {
    value: '',
    text : 'Select One',
  },
  {
    value: 'stainless_steel',
    text : 'Stainless Steel (+10)',
  },
];

export const lengthOptions = [
  { value: '', text: 'Select One' },
  { value: '1', text: '1"' },
  { value: '2', text: '2"' },
  { value: '3', text: '3"' },
  { value: '4', text: '4"' },
  { value: '5', text: '5"' },
  { value: '6', text: '6"' },
  { value: '7', text: '7"' },
  { value: '8', text: '8"' },
  { value: '9', text: '9"' },
  { value: '10', text: '10"' },
];

export const widthOptions = [
  { value: '', text: 'Select One' },
  { value: '1', text: '1"' },
  { value: '2', text: '2"' },
  { value: '3', text: '3"' },
  { value: '4', text: '4"' },
  { value: '5', text: '5"' },
  { value: '6', text: '6"' },
  { value: '7', text: '7"' },
  { value: '8', text: '8"' },
  { value: '9', text: '9"' },
  { value: '10', text: '10"' },
];
